<template>
  <div v-if="globals.isAccessAllowed('LoopOp_Clients_ReadAll')">
    <!-- This component displays the client management  -->

    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="clients-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            id="client-management-refresh-button"
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getClientData()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.C0000 }}
          </button>
          <button
            id="client-management-create-button"
            class="btn btn-raised btn-top-bar"
            @click="(selectedClient = -1), openEditClientDialog('create')"
            :disabled="!globals.isAccessAllowed('LoopOp_Clients_Create')"
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.C0001 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openEditClientDialog('edit')"
            :disabled="
              selectedClient == -1 ||
              !globals.isAccessAllowed('LoopOp_Clients_Read')
            "
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.C0002 }}
          </button>
          <!-- <button class="btn btn-raised btn-top-bar" :disabled="true">
          <i class="material-icons md-36">map</i><br>{{lang.C0005}}</button>-->
          <button
            class="btn btn-raised btn-top-bar"
            @click="
              (editSurveyDialogModeAdd = true), (showEditSurveyDialog = true)
            "
            :disabled="
              selectedClient == -1 ||
              !globals.isAccessAllowed('LoopOp_Surveys_Create')
            "
          >
            <i class="material-icons md-36">playlist_add</i>
            <br />
            {{ lang.C0006 }}
          </button>
          <button
            id="client-management-importer-button"
            class="btn btn-raised btn-top-bar"
            v-if="
              feature.isEnabled('audi_importers') &&
              globals.operationPermitted('Entities.Importer.AllowRead')
            "
            @click="showImportersModal = true"
          >
            <i class="material-icons md-36">language</i>
            <br />
            {{ lang.C0118 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-7">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="text"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.C0007"
              v-model="searchString"
              @keyup.enter="(selectedPage = 1), filterClientData()"
            />
          </div>
        </div>

        <div class="col-lg-5">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.C0008 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == -1 }"
                    role="button"
                    @click="updatePaging(1, -1)"
                    >{{ lang.C0009 }}</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{
                disabled: !filteredClientData.length || selectedPage == 1,
              }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.C0010 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="numberOfPages() > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="numberOfPages() > 7 && selectedPage < numberOfPages() - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled:
                  !filteredClientData.length || selectedPage == numberOfPages(),
              }"
              @click="updatePaging(numberOfPages(), 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.C0011 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="clientsTotalElementsCounter">{{
                filteredClientData.length
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="clientsTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.C0119 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table class="table table-striped table-hover main-table">
            <thead>
              <tr>
                <!-- Add table headers here -->
                <!-- The table sort is triggered by click on the header -->
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('id')"
                  >
                    {{ lang.C0012 }}
                    <span
                      v-if="sortField == 'id' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'id' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('name')"
                  >
                    {{ lang.C0013 }}
                    <span
                      v-if="sortField == 'name' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'name' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('address')"
                  >
                    {{ lang.C0014 }}
                    <span
                      v-if="sortField == 'address' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'address' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('city')"
                  >
                    {{ lang.C0015 }}
                    <span
                      v-if="sortField == 'city' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'city' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('region')"
                  >
                    {{ lang.C0016 }}
                    <span
                      v-if="sortField == 'region' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'region' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('postalcode')"
                  >
                    {{ lang.C0017 }}
                    <span
                      v-if="sortField == 'postalcode' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'postalcode' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortClientData('country')"
                  >
                    {{ lang.C0018 }}
                    <span
                      v-if="sortField == 'country' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'country' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- Doubleclick on the table row opens the edit dialog, singleclick selects the client -->
              <tr
                role="button"
                v-for="client in clientDataOnCurrentPage"
                :key="client.ClientId"
                @click="selectedClient = client.ClientId"
                @dblclick="
                  !globals.isAccessAllowed('LoopOp_Clients_Read') ||
                    openEditClientDialog('edit')
                "
                :class="{ info: client.ClientId == selectedClient }"
              >
                <!-- Add table data here -->
                <td>{{ client.ClientId }}</td>
                <td>{{ client.ClientName }}</td>
                <td>{{ client.ClientAddress }}</td>
                <td>{{ client.ClientCity }}</td>
                <td>{{ client.ClientRegionName }}</td>
                <td>{{ client.ClientPostalCode }}</td>
                <td>{{ client.ClientCountry }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for editing or creating new clients -->
    <div
      class="modal fade"
      id="editClient"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form id="editForm">
            <div class="modal-header">
              <!-- Close button in the upper right corner -->
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>

              <!-- Modal Title -->
              <h4 class="modal-title">
                <b>{{ editClientDialogData.dialogTitle }}</b>
              </h4>

              <!-- Client ID, if available -->
              <div
                v-if="
                  typeof editClientDialogData.clientData.ClientId != 'undefined'
                "
              >
                <label class="control-label"
                  >{{ lang.C0019 }}:
                  {{ editClientDialogData.clientData.ClientId }}</label
                >
              </div>
            </div>
            <div class="modal-body">
              <!-- Accordion - hides content that is not used -->
              <div
                class="panel-group"
                id="accordion"
                role="tablist"
                aria-multiselectable="true"
              >
                <div class="panel panel-default">
                  <!-- Accordion entry 1 -->
                  <div
                    class="panel-heading"
                    role="button"
                    id="headingGeneral"
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapseGeneral"
                    aria-expanded="true"
                    aria-controls="collapseGeneral"
                  >
                    <h4 class="panel-title">
                      <a class="collapsed">{{ lang.C0020 }}</a>
                    </h4>
                  </div>
                  <div
                    id="collapseGeneral"
                    class="panel-collapse collapse in"
                    role="tabpanel"
                    aria-labelledby="headingGeneral"
                  >
                    <div class="panel-body">
                      <!-- Add inputs here -->
                      <div class="form-group">
                        <label
                          for="inputClientName"
                          class="col-md-2 control-label"
                          >{{ lang.C0021 }}*</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputClientName"
                            name="inputClientName"
                            v-model="editClientDialogData.clientData.ClientName"
                            @keyup="validateInput('inputClientName')"
                            required
                          />
                          <span
                            v-show="inputHasError('inputClientName')"
                            class="help-block error text-danger"
                            >{{ lang.C0090 }}</span
                          >
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputAddress"
                          class="col-md-2 control-label"
                          >{{ lang.C0022 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputAddress"
                            v-model="
                              editClientDialogData.clientData.ClientAddress
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputAddress2"
                          class="col-md-2 control-label"
                          >{{ lang.C0023 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputAddress2"
                            v-model="
                              editClientDialogData.clientData.ClientAddress2
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputCity" class="col-md-2 control-label">{{
                          lang.C0024
                        }}</label>
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputCity"
                            v-model="editClientDialogData.clientData.ClientCity"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputCountry"
                          class="col-md-2 control-label"
                          >{{ lang.C0027 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            class="form-control"
                            @change="
                              changedCountry(
                                editClientDialogData.clientData.ClientCountry,
                                'general'
                              )
                            "
                            v-model="
                              editClientDialogData.clientData.ClientCountry
                            "
                          >
                            <option disabled :value="'undefined'" hidden>
                              {{ lang.C0026 }}
                            </option>
                            <option
                              v-for="(country, ISOCode) in globals.countryList"
                              :key="ISOCode"
                              :value="ISOCode"
                            >
                              {{ country }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputRegion"
                          class="col-md-2 control-label"
                          >{{ lang.C0025 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            class="form-control"
                            v-model="
                              editClientDialogData.clientData.ClientRegionGuid
                            "
                            :disabled="
                              editClientDialogData.currentRegionsGeneral
                                .length < 1
                            "
                          >
                            <option
                              disabled
                              :value="'undefined'"
                              hidden
                              v-if="
                                editClientDialogData.currentRegionsGeneral
                                  .length > 0
                              "
                            >
                              {{ lang.C0026 }}
                            </option>
                            <option
                              v-for="region in editClientDialogData.currentRegionsGeneral"
                              :key="region.RegionGuid"
                              :value="region.RegionGuid"
                            >
                              {{ region.RegionName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputTimeZone"
                          class="col-md-2 control-label"
                          >{{ lang.C0030 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            class="form-control"
                            v-model="
                              editClientDialogData.clientData.ClientTimeZoneId
                            "
                            :disabled="
                              editClientDialogData.currentTimeZonesGeneral
                                .length < 1
                            "
                          >
                            <option
                              disabled
                              :value="'undefined'"
                              hidden
                              v-if="
                                editClientDialogData.currentTimeZonesGeneral
                                  .length > 0
                              "
                            >
                              {{ lang.C0026 }}
                            </option>
                            <option
                              v-for="tz in editClientDialogData.currentTimeZonesGeneral"
                              :key="tz.TimeZoneId"
                              :value="tz.TimeZoneId"
                            >
                              {{ tz.TimeZoneName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputPostalCode"
                          class="col-md-2 control-label"
                          >{{ lang.C0028 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputPostalCode"
                            v-model="
                              editClientDialogData.clientData.ClientPostalCode
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group form-check-container">
                        <label
                          for="CXKunde"
                          :title="lang.C0125"
                          class="col-md-2 control-label"
                          >{{ lang.C0124 }}</label
                        >
                        <div class="col-md-10">
                          <div class="checkbox" style="float: left">
                            <label :title="lang.C0125">
                              <input
                                @change="setCXKunde"
                                data-toggle="tooltip"
                                type="checkbox"
                                id="CXKunde"
                                v-model="
                                  editClientDialogData.clientData.ClientCx
                                "
                              />
                              <span class="checkbox-material"
                                ><span class="check"></span
                              ></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputSinceClientMgmtEdit"
                          class="col-md-2 control-label"
                          >{{ lang.C0029 }}</label
                        >
                        <div
                          class="col-md-10"
                          @click="
                            globals.toggleFlatpickr('inputSinceClientMgmtEdit')
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="inputSinceClientMgmtEdit"
                            v-model="
                              editClientDialogData.clientData.ClientSince
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="selectClientTypeClientMgmtEdit"
                          class="col-md-2 control-label"
                          >{{ lang.C0120 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            id="selectClientTypeClientMgmtEdit"
                            class="form-control"
                            v-model="
                              editClientDialogData.clientData.ClientTypeGuid
                            "
                          >
                            <option
                              v-for="type in clientTypes"
                              :key="type.ClientTypeGuid"
                              :value="type.ClientTypeGuid"
                            >
                              {{ type.ClientTypeName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="selectClientStatusClientMgmtEdit"
                          class="col-md-2 control-label"
                          >{{ lang.C0121 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            id="selectClientStatusClientMgmtEdit"
                            class="form-control"
                            v-model="
                              editClientDialogData.clientData.ClientStatusId
                            "
                          >
                            <option value="A">{{ lang.C0122 }}</option>
                            <option value="I">{{ lang.C0123 }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputAdditionalInfo"
                          class="col-md-2 control-label"
                          >{{ lang.C0031 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputAdditionalInfo"
                            v-model="
                              editClientDialogData.clientData
                                .ClientAdditionalInfo
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Accordion entry 2 -->
                  <div
                    class="panel-heading"
                    role="button"
                    id="headingContact"
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapseContact"
                    aria-expanded="false"
                    aria-controls="collapseContact"
                  >
                    <h4 class="panel-title">
                      <a class="collapsed">{{ lang.C0032 }}</a>
                    </h4>
                  </div>
                  <div
                    id="collapseContact"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="headingContact"
                  >
                    <div class="panel-body">
                      <div class="form-group">
                        <label
                          for="inputContactFirstname"
                          class="col-md-2 control-label"
                          >{{ lang.C0033 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputContactFirstname"
                            v-model="
                              editClientDialogData.clientData
                                .ClientContactFirstName
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputContactLastname"
                          class="col-md-2 control-label"
                          >{{ lang.C0034 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputContactLastname"
                            v-model="
                              editClientDialogData.clientData
                                .ClientContactLastName
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputContactPhone"
                          class="col-md-2 control-label"
                          >{{ lang.C0035 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="tel"
                            class="form-control"
                            id="inputContactPhone"
                            name="inputContactPhone"
                            v-model="
                              editClientDialogData.clientData.ClientContactPhone
                            "
                            @keyup="validateInput('inputContactPhone')"
                          />
                          <span
                            v-show="inputHasError('inputContactPhone')"
                            class="help-block error text-danger"
                            >{{ lang.C0091 }}</span
                          >
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputContactFax"
                          class="col-md-2 control-label"
                          >{{ lang.C0036 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="tel"
                            class="form-control"
                            id="inputContactFax"
                            name="inputContactFax"
                            v-model="
                              editClientDialogData.clientData.ClientContactFax
                            "
                            @keyup="validateInput('inputContactFax')"
                          />
                          <span
                            v-show="inputHasError('inputContactFax')"
                            class="help-block error text-danger"
                            >{{ lang.C0092 }}</span
                          >
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputContactEmail"
                          class="col-md-2 control-label"
                          >{{ lang.C0037 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="email"
                            class="form-control"
                            id="inputContactEmail"
                            name="inputContactEmail"
                            v-model="
                              editClientDialogData.clientData.ClientContactEmail
                            "
                            @keyup="validateInput('inputContactEmail')"
                          />
                          <span
                            v-show="inputHasError('inputContactEmail')"
                            class="help-block error text-danger"
                            >{{ lang.C0094 }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Accordion entry 3 -->
                  <div
                    class="panel-heading"
                    role="button"
                    id="headingBillingDetail"
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapseBillingDetail"
                    aria-expanded="false"
                    aria-controls="collapseBillingDetail"
                  >
                    <h4 class="panel-title">
                      <a class="collapsed">{{ lang.C0038 }}</a>
                    </h4>
                  </div>
                  <div
                    id="collapseBillingDetail"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="headingBillingDetail"
                  >
                    <div class="panel-body">
                      <div class="form-group">
                        <label
                          for="inputBillTo"
                          class="col-md-2 control-label"
                          >{{ lang.C0039 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputBillTo"
                            v-model="
                              editClientDialogData.clientData.ClientBillTo
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingAddress"
                          class="col-md-2 control-label"
                          >{{ lang.C0040 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputBillingAddress"
                            v-model="
                              editClientDialogData.clientData
                                .ClientBillingAddress
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingAddress2"
                          class="col-md-2 control-label"
                          >{{ lang.C0041 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputBillingAddress2"
                            v-model="
                              editClientDialogData.clientData
                                .ClientBillingAddress2
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingCity"
                          class="col-md-2 control-label"
                          >{{ lang.C0042 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputBillingCity"
                            v-model="
                              editClientDialogData.clientData.ClientBillingCity
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingCountry"
                          class="col-md-2 control-label"
                          >{{ lang.C0044 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            class="form-control"
                            @change="
                              changedCountry(
                                editClientDialogData.clientData
                                  .ClientBillingCountry,
                                'billing'
                              )
                            "
                            v-model="
                              editClientDialogData.clientData
                                .ClientBillingCountry
                            "
                          >
                            <option disabled :value="'undefined'" hidden>
                              {{ lang.C0026 }}
                            </option>
                            <option
                              v-for="(country, ISOCode) in globals.countryList"
                              :key="ISOCode"
                              :value="ISOCode"
                            >
                              {{ country }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingRegion"
                          class="col-md-2 control-label"
                          >{{ lang.C0043 }}</label
                        >
                        <div class="col-md-10">
                          <select
                            class="form-control"
                            v-model="
                              editClientDialogData.clientData
                                .ClientBillingRegionGuid
                            "
                            :disabled="
                              editClientDialogData.currentRegionsBilling
                                .length < 1
                            "
                          >
                            <option
                              disabled
                              :value="'undefined'"
                              hidden
                              v-if="
                                editClientDialogData.currentRegionsBilling
                                  .length > 0
                              "
                            >
                              {{ lang.C0026 }}
                            </option>
                            <option
                              v-for="region in editClientDialogData.currentRegionsBilling"
                              :key="region.RegionGuid"
                              :value="region.RegionGuid"
                            >
                              {{ region.RegionName }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingPostalCode"
                          class="col-md-2 control-label"
                          >{{ lang.C0045 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputBillingPostalCode"
                            v-model="
                              editClientDialogData.clientData
                                .ClientBillingPostalCode
                            "
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingEmail"
                          class="col-md-2 control-label"
                          >{{ lang.C0046 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="email"
                            class="form-control"
                            id="inputBillingEmail"
                            name="inputBillingEmail"
                            v-model="
                              editClientDialogData.clientData.ClientBillToEmail
                            "
                            @keyup="validateInput('inputBillingEmail')"
                          />
                          <span
                            v-show="inputHasError('inputBillingEmail')"
                            class="help-block error text-danger"
                            >{{ lang.C0094 }}</span
                          >
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="inputBillingTerms"
                          class="col-md-2 control-label"
                          >{{ lang.C0047 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="text"
                            class="form-control"
                            id="inputBillingTerms"
                            v-model="
                              editClientDialogData.clientData.ClientBillingTerms
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Accordion entry 4 -->
                  <div
                    class="panel-heading"
                    role="button"
                    id="headingPersonalization"
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapsePersonalization"
                    aria-expanded="false"
                    aria-controls="collapsePersonalization"
                  >
                    <h4 class="panel-title">
                      <a class="collapsed">{{ lang.C0048 }}</a>
                    </h4>
                  </div>
                  <div
                    id="collapsePersonalization"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="headingPersonalization"
                  >
                    <div class="panel-body">
                      <div class="form-group">
                        <label
                          for="inputLogoURL"
                          class="col-md-2 control-label"
                          >{{ lang.C0049 }}</label
                        >
                        <div class="col-md-10">
                          <input
                            type="url"
                            class="form-control"
                            id="inputLogoURL"
                            name="inputLogoURL"
                            v-model="
                              editClientDialogData.clientData.ClientPageLogoURL
                            "
                            @keyup="validateInput('inputLogoURL')"
                          />
                          <!-- <b-tooltip ref="tooltip" target="inputLogoURL" :delay="globals.tooltipDelay" placement="left">{{lang.C0050}}</b-tooltip> -->
                          <span
                            v-show="inputHasError('inputLogoURL')"
                            class="help-block error text-danger"
                            >{{ lang.C0093 }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Accordion entry 5 -->
                  <div
                    class="panel-heading"
                    role="button"
                    id="headingSurveys"
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapseSurveys"
                    aria-expanded="false"
                    aria-controls="collapseSurveys"
                    v-if="
                      selectedClient != -1 &&
                      globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
                    "
                  >
                    <h4 class="panel-title">
                      <a class="collapsed">{{ lang.C0059 }}</a>
                    </h4>
                  </div>
                  <div
                    id="collapseSurveys"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="headingSurveys"
                    v-if="
                      selectedClient != -1 &&
                      globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
                    "
                  >
                    <div class="panel-body">
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar btn-top-dialog"
                        :disabled="
                          editClientDialogData.selectedSurvey.SurveyId == -1 ||
                          !globals.isAccessAllowed('LoopOp_Surveys_Read')
                        "
                        @click="
                          (editSurveyDialogModeAdd = false),
                            (showEditSurveyDialog = true)
                        "
                      >
                        <i class="material-icons md-36">edit</i>
                        <br />
                        {{ lang.C0107 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar btn-top-dialog"
                        :disabled="
                          editClientDialogData.selectedSurvey.SurveyId == -1 ||
                          !globals.isAccessAllowed('LoopOp_Surveys_Read') ||
                          !globals.isAccessAllowed('LoopOp_Surveys_Update')
                        "
                        @click="
                          redirectToSurveyEditor(
                            editClientDialogData.selectedSurvey.SurveyId
                          )
                        "
                      >
                        <i class="material-icons md-36">playlist_add_check</i>
                        <br />
                        {{ lang.C0108 }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-raised btn-top-bar btn-top-dialog"
                        :disabled="
                          editClientDialogData.selectedSurvey.SurveyId == -1 ||
                          !globals.isAccessAllowed('LoopOp_Surveys_Delete')
                        "
                        @click="showDeleteSurveyModal = true"
                      >
                        <i class="material-icons md-36">clear</i>
                        <br />
                        {{ lang.C0109 }}
                      </button>

                      <!-- This table displays the surveys of a client -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <!-- Add table header here -->
                            <th style="width: 20%" class="text-center">
                              {{ lang.C0060 }}
                            </th>
                            <th style="width: 80%" class="text-center">
                              {{ lang.C0061 }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="survey in editClientDialogData.clientData
                              .Surveys"
                            :key="survey.SurveyId"
                            @click="
                              editClientDialogData.selectedSurvey.SurveyId =
                                survey.SurveyId
                            "
                            @dblclick="
                              (editSurveyDialogModeAdd = false),
                                (showEditSurveyDialog = true)
                            "
                            :class="{
                              info:
                                editClientDialogData.selectedSurvey.SurveyId ==
                                survey.SurveyId,
                            }"
                          >
                            <!-- Add table data here -->
                            <td>{{ survey.SurveyId }}</td>
                            <td>{{ survey.SurveyTitle }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Accordion entry 6 -->
                  <div
                    class="panel-heading"
                    role="button"
                    id="headingCustProp"
                    data-toggle="collapse"
                    data-parent="#accordion"
                    href="#collapseCustProp"
                    aria-expanded="false"
                    aria-controls="collapseCustProp"
                    v-if="selectedClient != -1"
                  >
                    <h4 class="panel-title">
                      <a class="collapsed">{{ lang.C0062 }}</a>
                    </h4>
                  </div>
                  <div
                    id="collapseCustProp"
                    class="panel-collapse collapse"
                    role="tabpanel"
                    aria-labelledby="headingCustProp"
                    v-if="selectedClient != -1"
                  >
                    <div class="panel-body">
                      <div class="form-group">
                        <label
                          for="inputCustProp"
                          class="col-md-2 control-label"
                          >{{ lang.C0063 }}</label
                        >
                        <div class="col-md-7">
                          <input
                            type="text"
                            class="form-control"
                            id="inputCustProp"
                            v-model="editClientDialogData.newCustomProperty"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-raised dialog-btn-primary"
                          style="margin-top: 0px"
                          @click="addNewCustomProperty()"
                          :disabled="canAddNewNewCustomProperty() === false"
                        >
                          {{ lang.C0064 }}
                        </button>
                      </div>

                      <!-- This table displays the custom properties a client -->
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <!-- Add table header here -->
                            <th style="width: 60%" class="text-center">
                              {{ lang.C0065 }}
                            </th>
                            <th style="width: 15%" class="text-center">
                              {{ lang.C0066 }}
                            </th>
                            <th style="width: 15%">{{ lang.C0103 }}</th>
                            <th style="width: 10%">{{ lang.C0067 }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="property in editClientDialogData.clientData
                              .CustomProperties"
                            :key="property.Position"
                          >
                            <!-- Add table data here -->
                            <td class="nopadding">
                              <div class="form-group nopadding">
                                <textarea
                                  rows="1"
                                  type="text"
                                  class="form-control text-center textarea-custom-properties autoExpand"
                                  style="margin: 0px"
                                  v-model="property.Name"
                                  :disabled="property.Cx"
                                ></textarea>
                              </div>
                            </td>
                            <td>{{ property.Id }}</td>
                            <td class="nopadding">
                              <div
                                class="form-group nopadding"
                                style="margin-right: 10px !important"
                              >
                                <select
                                  :disabled="property.Cx"
                                  class="form-control text-center nopadding"
                                  v-model="property.Visibility"
                                >
                                  <option value="0">{{ lang.C0104 }}</option>
                                  <option value="1">{{ lang.C0105 }}</option>
                                </select>
                              </div>
                            </td>
                            <td class="nopadding">
                              <div
                                class="form-group nopadding"
                                style="width: 60%; float: left"
                              >
                                <select
                                  class="form-control text-center nopadding"
                                  v-model="property.Position"
                                  @change="
                                    reorderCustomProperties(property.Name)
                                  "
                                >
                                  <option
                                    v-for="property2 in editClientDialogData
                                      .clientData.CustomProperties"
                                    :key="property2.Position"
                                    :value="property2.Position"
                                  >
                                    {{ property2.Position }}
                                  </option>
                                </select>
                              </div>
                              <div style="width: 40%; float: left">
                                <button
                                  type="button"
                                  class="btn"
                                  style="padding: 0px; margin: 7px"
                                  v-if="isCustomPropertyRemovable(property)"
                                  @click="
                                    openRemoveCustomPropertyDialog(property.Id)
                                  "
                                >
                                  <i
                                    class="material-icons md-24"
                                    style="color: red"
                                    >clear</i
                                  >
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <b-alert
                variant="danger"
                dismissible
                :show="editClientDialogData.showAlert"
                @dismissed="editClientDialogData.showAlert = false"
                >{{ lang.C0068 }}</b-alert
              >
            </div>
            <div class="modal-footer">
              <!-- Add modal buttons here -->
              <button
                type="button"
                class="btn btn-raised btn-default"
                data-dismiss="modal"
              >
                {{ lang.C0069 }}
              </button>
              <button
                id="client-management-save-button"
                type="button"
                class="btn btn-raised dialog-btn-primary"
                @click="validateBeforeSubmit('editClient')"
                :disabled="
                  !globals.isAccessAllowed('LoopOp_Clients_Update') &&
                  editClientDialogData.dialogType == 'edit'
                "
              >
                {{ lang.C0070 }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- This modal is for creating new surveys -->
    <SurveyManagementEditModal
      :selectedSurvey="editClientDialogData.selectedSurvey"
      :selectedClient="selectedClientData"
      :showDialog="showEditSurveyDialog"
      :dialogModeAdd="editSurveyDialogModeAdd"
      :languageList="languageList"
      :localesList="localesList"
      @surveyEditorRedirect="redirectToSurveyEditor"
      @dialogClosed="onEditSurveyDialogClosed"
      @dialogDataSaved="onEditSurveyDialogDataSaved"
    ></SurveyManagementEditModal>

    <!-- This modal is for the security check before deleting any custom property -->
    <div
      class="modal fade"
      id="removeCustomPropertySecurityDialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.C0110 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div class="form-group">
                <p>{{ lang.C0111 }}</p>
                <p>
                  {{ lang.C0112 }}
                  <b>{{ removeCustomPropertySecurityDialogData.propName }}</b>
                  {{ lang.C0113 }}
                </p>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.C0114 }}
            </button>
            <button
              type="button"
              class="btn btn-raised btn-danger"
              @click="
                removeCustomProperty(
                  removeCustomPropertySecurityDialogData.propId
                )
              "
            >
              {{ lang.C0115 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- This modal is for the security check before deleting a survey -->
    <confirmation-dialog
      :confirmationTitle="lang.C0116"
      :yesButtonText="lang.C0115"
      :noButtonText="lang.C0114"
      :showDialog="showDeleteSurveyModal"
      :colorRed="true"
      @onYesConfirmation="deleteSurvey"
      @dialogClosed="showDeleteSurveyModal = false"
    >
      <p>
        <b>{{ lang.C0117 }}</b>
      </p>
      <!-- Survey data is displayed here to let the user know which survey he is about to delete -->
      <div class="form-group">
        <label class="col-md-2 text-black">{{ lang.C0019 }}</label>
        <label class="col-md-10 text-black">{{
          editClientDialogData.selectedSurvey.SurveyId
        }}</label>
      </div>
      <div class="form-group">
        <label class="col-md-2 text-black">{{ lang.C0098 }}</label>
        <label class="col-md-10 text-black">{{
          getSelectedSurveyTitle()
        }}</label>
      </div>
    </confirmation-dialog>

    <ImporterManagement
      v-if="
        feature.isEnabled('audi_importers') &&
        globals.operationPermitted('Entities.Importer.AllowRead')
      "
      :showModal="showImportersModal"
      @modalClosed="showImportersModal = false"
    ></ImporterManagement>
  </div>
</template>

<script>
import SurveyManagementEditModal from "../SurveyManagement/SurveyManagementEditModal";
import ConfirmationDialog from "../Tools/Dialogs/ConfirmationDialog";
import ImporterManagement from "./ImporterManagement";
import UseClient from "../../services/Clients";
import UseUserSecurity from "../../services/UserSecurity";
import { getRange } from "../Tools/utils";
import UseSurvey from "../../services/Surveys";

export default {
  name: "ClientManagement",
  mounted() {
    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage)
      this.globals.getLanguageStrings(this, this.setClientTableHeight);
    this.getClientData();
    this.getEditClientDialogSelectData();
    this.getCPList();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setClientTableHeight).resize();

    this.globals.$once("ConfirmCXKundeYesConfirmation", () => {
      this.editClientDialogData.clientData.ClientCx = true;
    });
    this.globals.$once("ConfirmCXKundeNoConfirmation", () => {
      this.editClientDialogData.clientData.ClientCx = false;
    });
    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setClientTableHeight);
  },
  destroyed() {
    if (this.fpInputSince) this.fpInputSince.destroy();
    $(window).off("resize", this.setClientTableHeight);
    this.writeComponentSettingsToStore();
  },
  computed: {
    toLowerCaseForbidden() {
      return this.forbiddenCPs.map((e) => e.toLowerCase());
    },
    selectedClientData() {
      if (!this.clientData.length || this.selectedClient < 1) return null;
      return this.clientData.filter(
        (c) => c.ClientId === this.selectedClient
      )[0];
    },
  },
  methods: {
    currentCPNames(filterFn) {
      if (filterFn) {
        return this.editClientDialogData.clientData.CustomProperties.filter(
          filterFn
        ).map((e) => e.Name);
      } else {
        return this.editClientDialogData.clientData.CustomProperties.map(
          (e) => e.Name
        );
      }
    },
    getCPList() {
      // TODO: add real Endpoint
      UseUserSecurity.LocationProperties.getCxProperties().then((data) => {
        this.forbiddenCPs = data.data.CxPropertyNames;
      });
    },
    setCXKunde(_event) {
      if (
        !this.editClientDialogData.clientData.WasCX &&
        this.editClientDialogData.clientData.ClientCx
      ) {
        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "ConfirmCXKunde",
          confirmationTitle: this.lang.C0126,
          colorRed: false,
          yesButtonText: this.lang.C0128,
          noButtonText: this.lang.C0100,
          htmlText: `<p>${this.lang.C0127}</p>
          <br><p>${this.lang.C0129}</p>`,
        });
      }
    },
    setClientTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#clients-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards

        $(".table-space").css("max-height", height);
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/clientManagement"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName) {
          this.searchString = this.globals.removeWildcardsFromString(
            storedClient.ClientName
          );
        } else this.searchString = "";
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/clientManagement", {
        searchString: this.searchString,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (
          this.globals.removeWildcardsFromString(storedClient.ClientName) !==
          this.searchString
        ) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.globals.addWildcardsToString(this.searchString),
          });
        }
      }
    },
    correctTextareaHeight() {
      this.$nextTick(() => {
        let textareas = document.getElementsByClassName("autoExpand");
        for (let i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      return this.invalidInputIds.includes(id);
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialogId) {
      // [#1208] check dissalowed cp Names
      if (
        this.editClientDialogData.clientData.CustomProperties &&
        this.editClientDialogData.clientData.CustomProperties.length > 0
      ) {
        // filter new and old(notcx) props
        if (
          this.currentCPNames((el) => !el.LocationPropertyGuid).some(
            (cp) => !this.isAllowedCP(cp)
          )
        ) {
          this.globals.showErrorSnackbar(this.lang.C0131);
          return false;
        }

        const hasoldCX = this.currentCPNames(
          (el) => el.LocationPropertyGuid && !el.Cx
        ).some((cp) => !this.isAllowedCP(cp));
        if (hasoldCX && !this.editClientDialogData.clientData.ClientCx) {
          this.globals.showErrorSnackbar(this.lang.C0131);
          return false;
        }

        if (this.hasDuplicates(this.currentCPNames())) {
          this.globals.showErrorSnackbar(this.lang.C0132);
          return false;
        }
      }
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editClient") {
        this.editClientDialogData.showAlert = !result;
        if (!result) return;
        this.saveEditClientDialogData();
      }
      return true;
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },

    // Gets executed after the editSurveyDialog got closed
    onEditSurveyDialogClosed() {
      this.showEditSurveyDialog = false;
    },

    // Gets executed after the editSurveyDialog successfully saved some data
    onEditSurveyDialogDataSaved(savedSurvey) {
      if (!this.editSurveyDialogModeAdd) {
        var changedSurvey = this.editClientDialogData.clientData.Surveys.filter(
          (e) => {
            return (
              e.SurveyId == this.editClientDialogData.selectedSurvey.SurveyId
            );
          }
        );
        changedSurvey[0].SurveyTitle = savedSurvey.SurveyTitle;
      }
    },

    // Returns the title of the selected survey
    getSelectedSurveyTitle() {
      if (!this.editClientDialogData.clientData.Surveys) return "";
      let currentSurvey = this.editClientDialogData.clientData.Surveys.filter(
        (s) => {
          return (
            s.SurveyId == this.editClientDialogData.selectedSurvey.SurveyId
          );
        }
      );
      if (currentSurvey.length < 1) return "";
      return currentSurvey[0].SurveyTitle;
    },

    // Sends a delete request for the selected survey to the server
    deleteSurvey() {
      UseSurvey.deleteByD(this.editClientDialogData.selectedSurvey.SurveyId)
        .then((_res) => {
          this.globals.showSuccessSnackbar("Survey deletion successful");
          // If DELETE was successful, remove survey from survey list
          this.editClientDialogData.clientData.Surveys =
            this.editClientDialogData.clientData.Surveys.filter((e) => {
              return (
                e.SurveyId != this.editClientDialogData.selectedSurvey.SurveyId
              );
            });
          this.editClientDialogData.selectedSurvey.SurveyId = -1;
          this.showDeleteSurveyModal = false;
        })
        .catch(({ msg, Error }) => {
          console.error("Error on DELETE in deleteSurvey()", msg);
          this.globals.showErrorSnackbar("Survey deletion failed");
        });
    },

    // Redirects to the survey editor component in a new tab to edit the survey with the given ID
    redirectToSurveyEditor(surveyId) {
      $.ajax({
        method: "PATCH",
        url: `api/Surveys/${surveyId}/Lock`,
        data: '{ "Lock": true }',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) this.globals.showErrorSnackbar(data.Error);
          else {
            $("#editClient").modal("hide");
            window.name = `MSMLoopMainApp`;
            window.open(`${window.origin}/survey.html#/editor/${surveyId}`);
          }
        },
        error: () => {
          console.error("Error on PATCH in redirectToSurveyEditor()");
          this.globals.showErrorSnackbar("Survey lock failed");
        },
      });
    },

    isAllowedCP(cp) {
      if (!(typeof cp === "string")) return false;
      if (cp.length === 0) return false;
      if (this.forbiddenCPs.includes(cp)) return false;
      if (this.toLowerCaseForbidden.includes(cp.toLowerCase())) return false;
      return true;
    },

    /**
     * returns true if a given array of strings contains duplicates
     * @param {string[]} arr
     * @returns {boolean}
     */
    hasDuplicates(arr) {
      const cps = arr;
      const unique = Array.from(new Set(cps));
      return unique.length !== cps.length;
    },

    canAddNewNewCustomProperty() {
      if (this.editClientDialogData.newCustomProperty.trim() === "") {
        return false;
      }
      if (
        this.editClientDialogData.clientData.CustomProperties &&
        this.editClientDialogData.clientData.CustomProperties.find(
          (v) => v.Name === this.editClientDialogData.newCustomProperty.trim()
        )
      ) {
        return false;
      }
      return true;
    },

    // Adds a new custom property to client data
    addNewCustomProperty() {
      if (this.editClientDialogData.newCustomProperty.trim() === "") {
        this.globals.showErrorSnackbar(this.lang.C0130);
        return;
      }

      this.editClientDialogData.newCustomProperty =
        this.editClientDialogData.newCustomProperty.trim();

      if (!this.isAllowedCP(this.editClientDialogData.newCustomProperty)) {
        this.globals.showErrorSnackbar(this.lang.C0131);
        return;
      }

      if (!("CustomProperties" in this.editClientDialogData.clientData))
        this.editClientDialogData.clientData.CustomProperties = [];

      var newProp = {
        ID: "",
        Name: this.editClientDialogData.newCustomProperty,
        Visibility: 0,
        Position:
          this.editClientDialogData.clientData.CustomProperties.length + 1,
      };
      this.editClientDialogData.clientData.CustomProperties.push(newProp);
      this.editClientDialogData.newCustomProperty = "";

      this.correctTextareaHeight();
    },

    // Shows a security dialog to ask the user if a custom property should really be deleted
    openRemoveCustomPropertyDialog(propId) {
      this.removeCustomPropertySecurityDialogData.propId = propId;
      this.removeCustomPropertySecurityDialogData.propName =
        this.editClientDialogData.clientData.CustomProperties.filter((prop) => {
          return prop.Id == propId;
        })[0].Name;
      $("#removeCustomPropertySecurityDialog").modal("show");
    },

    // Removes the custom property with the given ID from the client data
    removeCustomProperty(propId) {
      var position =
        this.editClientDialogData.clientData.CustomProperties.filter((prop) => {
          return prop.Id == propId;
        })[0].Position;

      this.editClientDialogData.clientData.CustomProperties =
        this.editClientDialogData.clientData.CustomProperties.filter((prop) => {
          return prop.Id != propId;
        });

      var prop;
      for (prop of this.editClientDialogData.clientData.CustomProperties) {
        if (prop.Position > position) prop.Position--;
      }

      $("#removeCustomPropertySecurityDialog").modal("hide");
      this.$forceUpdate();
      this.correctTextareaHeight();
    },

    // Reorders custom properties after the position of a property changed
    reorderCustomProperties() {
      var allPositions = getRange(
        1,
        this.editClientDialogData.clientData.CustomProperties.length,
        1
      );
      var missingPos = 0;
      var newPos = 0;
      var propName = "";

      // Find missing position number and the position and name of the changed property
      for (var i = 0; i < allPositions.length; i++) {
        if (
          this.editClientDialogData.clientData.CustomProperties[i].Position !=
          allPositions[i]
        ) {
          missingPos = allPositions[i];
          newPos =
            this.editClientDialogData.clientData.CustomProperties[i].Position;
          propName =
            this.editClientDialogData.clientData.CustomProperties[i].Name;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (
          this.editClientDialogData.clientData.CustomProperties[i].Name !=
          propName
        ) {
          // Do NOT move the changed property
          if (
            this.editClientDialogData.clientData.CustomProperties[i].Position <
              missingPos &&
            this.editClientDialogData.clientData.CustomProperties[i].Position >=
              newPos
          ) {
            this.editClientDialogData.clientData.CustomProperties[i].Position++;
          }
          if (
            this.editClientDialogData.clientData.CustomProperties[i].Position >
              missingPos &&
            this.editClientDialogData.clientData.CustomProperties[i].Position <=
              newPos
          ) {
            this.editClientDialogData.clientData.CustomProperties[i].Position--;
          }
        }
      }
      this.sortCustomPropertiesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },

    // Sorts the available custom properties by their position number
    sortCustomPropertiesByPosition() {
      if (
        typeof this.editClientDialogData.clientData.CustomProperties ==
        "undefined"
      )
        return;
      this.editClientDialogData.clientData.CustomProperties.sort((a, b) => {
        return a.Position - b.Position;
      });
      this.correctTextareaHeight();
    },
    /**
     * returns true if you can remove that property
     */
    isCustomPropertyRemovable(prop) {
      let ret = false;
      switch (true) {
        case prop.LocationPropertyGuid ===
          "F65898B5-4D53-4E4E-959A-06D128D9F7FE":
          ret = false;
          break;
        case prop.LocationPropertyGuid ===
          "B820479A-0F40-4584-9C76-8553AD91276D":
          ret = false;
          break;
        case prop.Cx:
          ret = false;
          break;
        default:
          ret = true;
          break;
      }
      return ret;
    },

    // Refreshes the region list in the dropdown of the editClient dialog depending on the selected country
    changedCountry(country, section) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (typeof this.regionList != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          regionObj = this.regionList.filter((region) => {
            // Filter regions for the given country
            return (
              region.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >=
              0
            );
          });
        }
      }

      if (typeof this.timeZones != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          tzObj = this.timeZones.filter((tz) => {
            // Filter timezones for the given country
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (section == "general") {
        if (regionObj.length == 0)
          this.editClientDialogData.currentRegionsGeneral = [];
        else
          this.editClientDialogData.currentRegionsGeneral =
            regionObj[0].Regions;

        if (tzObj.length == 0)
          this.editClientDialogData.currentTimeZonesGeneral = [];
        else
          this.editClientDialogData.currentTimeZonesGeneral =
            tzObj[0].TimeZones;

        var idx = this.editClientDialogData.currentRegionsGeneral
          .map((e) => {
            return e.RegionGuid;
          })
          .indexOf(this.editClientDialogData.clientData.ClientRegionGuid);

        if (idx < 0)
          delete this.editClientDialogData.clientData.ClientRegionGuid;

        idx = this.editClientDialogData.currentTimeZonesGeneral
          .map((e) => {
            return e.TimeZoneId;
          })
          .indexOf(this.editClientDialogData.clientData.ClientTimeZoneId);

        if (idx < 0)
          delete this.editClientDialogData.clientData.ClientTimeZoneId;
      } else if (section == "billing") {
        if (regionObj.length == 0)
          this.editClientDialogData.currentRegionsBilling = [];
        else
          this.editClientDialogData.currentRegionsBilling =
            regionObj[0].Regions;

        var idx = this.editClientDialogData.currentRegionsBilling
          .map((e) => {
            return e.RegionGuid;
          })
          .indexOf(
            this.editClientDialogData.clientData.ClientBillingRegionGuid
          );

        if (idx < 0)
          delete this.editClientDialogData.clientData.ClientBillingRegionGuid;
      }
    },

    // Opens the editClient dialog after dialog data received
    editClientDialogDataReceived() {
      $("#editClient").modal("show");

      if ($("#collapseCustProp").attr("aria-expanded")) {
        $("#editClient").off("shown.bs.modal", this.correctTextareaHeight);
        $("#editClient").on("shown.bs.modal", this.correctTextareaHeight);
      }
      $("#collapseCustProp").off(
        "shown.bs.collapse",
        this.correctTextareaHeight
      );
      $("#collapseCustProp").on(
        "shown.bs.collapse",
        this.correctTextareaHeight
      );
    },

    // Fills the editClient dialog with data, depending on the dialog mode.
    // Available modes: "create" --> New client is created, default values are set
    //                  "edit" --> Edit existing client, catch values from server
    openEditClientDialog(mode) {
      this.fpInputSince = flatpickr(
        "#inputSinceClientMgmtEdit",
        this.globals.flatpickrDateConfig
      );

      if (mode == "create") {
        this.editClientDialogData.dialogTitle = this.lang.C0088;
        this.editClientDialogData.dialogType = "create";
        delete this.editClientDialogData.clientData.ClientId;
        delete this.editClientDialogData.clientData.ClientName;
        delete this.editClientDialogData.clientData.ClientAddress;
        delete this.editClientDialogData.clientData.ClientAddress2;
        delete this.editClientDialogData.clientData.ClientCity;
        delete this.editClientDialogData.clientData.ClientRegionName;
        delete this.editClientDialogData.clientData.ClientPostalCode;
        delete this.editClientDialogData.clientData.ClientCountry;
        delete this.editClientDialogData.clientData.ClientSince;
        delete this.editClientDialogData.clientData.ClientContactFirstName;
        delete this.editClientDialogData.clientData.ClientContactLastName;
        delete this.editClientDialogData.clientData.ClientContactPhone;
        delete this.editClientDialogData.clientData.ClientContactFax;
        delete this.editClientDialogData.clientData.ClientContactEmail;
        delete this.editClientDialogData.clientData.ClientBillTo;
        delete this.editClientDialogData.clientData.ClientBillingAddress;
        delete this.editClientDialogData.clientData.ClientBillingAddress2;
        delete this.editClientDialogData.clientData.ClientBillingCity;
        delete this.editClientDialogData.clientData.ClientBillingState_Region;
        delete this.editClientDialogData.clientData.ClientBillingCountry;
        delete this.editClientDialogData.clientData.ClientBillingPostalCode;
        delete this.editClientDialogData.clientData.ClientBillToEmail;
        delete this.editClientDialogData.clientData.ClientBillingTerms;
        delete this.editClientDialogData.clientData.ClientTimeZoneId;
        delete this.editClientDialogData.clientData.ClientAdditionalInfo;
        delete this.editClientDialogData.clientData.ClientPageLogoURL;
        this.editClientDialogData.clientData.ClientStatusId = "A";
        this.editClientDialogData.clientData.ClientTypeGuid =
          "3B5C81B1-1F9A-4EC1-8138-E42C58236FB1"; // Real client
        this.editClientDialogData.clientData.Surveys = [];
        this.editClientDialogData.clientData.CustomProperties = [];

        this.changedCountry("", "general");
        this.changedCountry("", "billing");
        $("#editClient").modal("show");
        this.fpInputSince.clear();
      } else if (mode == "edit") {
        this.editClientDialogData.dialogTitle = this.lang.C0089;
        this.editClientDialogData.dialogType = "edit";
        this.editClientDialogData.clientData = {};
        UseClient.getClientbyID(this.selectedClient)
          .then((res) => {
            let data = res.data;
            this.editClientDialogDataReceived();
            this.editClientDialogData.clientData = data; // Store response data from server
            this.changedCountry(
              this.editClientDialogData.clientData.ClientCountry,
              "general"
            ); // Load region dropdown depending on the selected country
            this.changedCountry(
              this.editClientDialogData.clientData.ClientBillingCountry,
              "billing"
            );
            this.sortCustomPropertiesByPosition();

            this.fpInputSince.setDate(
              this.editClientDialogData.clientData.ClientSince
            );
          })
          .catch((errObj) => {
            console.error(
              "Client data access failed in openEditClientDialog()"
            );
            console.error(errObj);
            this.globals.showErrorSnackbar("Client data access failed");
          });
      } else {
        // Wrong mode
        console.error("Wrong client dialog mode in openEditClientDialog()");
        $("#editClient").modal("hide");
        return false;
      }
      this.editClientDialogData.selectedSurvey.SurveyId = -1;
      this.editClientDialogData.showAlert = false;
      this.resetValidationErrors("editClient");
      return true; // Mode was ok
    },

    // Catches data for dropdown lists from server
    getEditClientDialogSelectData() {
      if (this.globals.selectedLanguage) this.globals.getCountryList();
      this.globals.getRegionsList((callbackData) => {
        this.regionList = callbackData;
      });
      this.globals.getTimezonesList((callbackData) => {
        this.timeZones = callbackData;
      });
      this.globals.getLanguageList((callbackData) => {
        this.languageList = callbackData;
      });
      this.globals.getLocaleList((callbackData) => {
        this.localesList = callbackData;
      });
      this.globals.getClientTypes((callbackData) => {
        this.clientTypes = callbackData;
      });
    },

    // Sends the data from editClient dialog to the server to store it in the database
    saveEditClientDialogData() {
      if (!this.editClientDialogData.clientData.ClientTypeGuid)
        this.editClientDialogData.clientData.ClientTypeGuid =
          "3B5C81B1-1F9A-4EC1-8138-E42C58236FB1"; // Real client

      if (this.editClientDialogData.dialogType == "create") {
        // Create new client

        this.editClientDialogData.clientData.ClientCx =
          !!this.editClientDialogData.clientData.ClientCx;
        UseClient.createClient(this.editClientDialogData.clientData)
          .then((res) => {
            let data = res.data;
            $("#editClient").modal("hide");
            this.globals.showSuccessSnackbar("Client creation successful");

            this.globals.clientList = [];
            this.getClientData();

            if (data && data[0] && data[0].ClientId)
              this.selectedClient = data[0].ClientId;
          })
          .catch((err) => {
            console.error("Error on POST in saveEditClientDialogData(),", err);
            this.globals.showErrorSnackbar("Client creation failed");
          });
      } else if (this.editClientDialogData.dialogType == "edit") {
        // Update existing client
        UseClient.updateClient(
          this.editClientDialogData.clientData.ClientId,
          this.editClientDialogData.clientData
        )
          .then((_res) => {
            $("#editClient").modal("hide");
            this.globals.showSuccessSnackbar("Client update successful");

            this.globals.clientList = [];
            this.getClientData();
          })
          .catch((err) => {
            console.error("Error on PUT in saveEditClientDialogData()", err);
            this.globals.showErrorSnackbar("Client update failed");
          });
      } else
        console.error("Wrong client dialog mode in saveEditClientDialogData()");
    },

    // Calculates the sort order for the given column and triggers the filter where the clientdata will be sorted
    sortClientData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.filterClientData();
    },

    // Catches client data for the table from the server
    getClientData() {
      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded
      UseClient.getClients()
        .then(({ data }) => {
          this.clientData = [];
          if (!_.isEmpty(data)) this.clientData = data;
          this.filterClientData();
        })
        .catch((err) => {
          console.error("Error on GET in getClientData()");
          this.globals.showErrorSnackbar("Cant get Clients");
        })
        .finally((r) => {
          this.refreshEnabled = true; // Enable refresh of the client data after server response
        });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the reload of the page
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfClientData();
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return getRange(1, this.numberOfPages(), 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return getRange(1, 6, 1);
      } else if (
        this.numberOfPages() > 7 &&
        this.selectedPage >= this.numberOfPages() - 3
      ) {
        return getRange(this.numberOfPages() - 5, this.numberOfPages(), 1);
      } else {
        return getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },

    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredClientData.length % this.pageSize == 0)
        return this.filteredClientData.length / this.pageSize;
      else return parseInt(this.filteredClientData.length / this.pageSize) + 1;
    },

    // Selects the client data that has to be displayed on the selected page
    loadCurrentPageOfClientData() {
      if (this.pageSize == -1)
        this.clientDataOnCurrentPage = this.filteredClientData;
      else {
        // Display all data, no pages
        this.clientDataOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredClientData[i] != null)
            this.clientDataOnCurrentPage[i - startIndex] =
              this.filteredClientData[i];
        }
      }
    },

    // Filters the client data by every single word in the searchString, separated by a blank
    // and triggers the sorting and the reload of the selected page, so that the expected data is displayed on the table
    filterClientData() {
      if (!this.searchString) this.filteredClientData = this.clientData;
      let words = [...this.searchString.trim().split(" ")];

      let keys = [
        "ClientId",
        "ClientName",
        "ClientAddress",
        "ClientPostalCode",
        "ClientCity",
        "ClientRegionCode",
        "ClientCountry",
      ];

      /**
       * Returns true if any word is contained in any of the keys of the client or the words are empty
       */
      const clientFilter = (client) => {
        let containsSearch = false;
        if (words[0].length <= 0) return true;
        words.forEach((word) => {
          return keys.forEach((key) => {
            if (!containsSearch)
              containsSearch =
                client[key] &&
                client[key]
                  .toString()
                  .toLowerCase()
                  .includes(word.toLowerCase());
          });
        });
        return containsSearch;
      };
      this.filteredClientData = !_.isEmpty(this.clientData)
        ? this.clientData.filter(clientFilter)
        : [];

      this.startSorting(this.filteredClientData); // Sort the filtered data
      this.loadCurrentPageOfClientData(); // Display selected page of filtered and sorted data
    },

    // Sorts the clientData depending on the selected column and sort order
    startSorting(clientData) {
      // Sort by ID
      switch (this.sortField) {
        case "id":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              return a.ClientId - b.ClientId;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              return a.ClientId - b.ClientId;
            });
          break;
        case "name":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase())
                return -1;
              if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase())
                return 1;
              return 0;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase())
                return -1;
              if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase())
                return 1;
              return 0;
            });
          break;
        case "address":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              if (a.ClientAddress.toLowerCase() < b.ClientAddress.toLowerCase())
                return -1;
              if (a.ClientAddress.toLowerCase() > b.ClientAddress.toLowerCase())
                return 1;
              return 0;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              if (a.ClientAddress.toLowerCase() < b.ClientAddress.toLowerCase())
                return -1;
              if (a.ClientAddress.toLowerCase() > b.ClientAddress.toLowerCase())
                return 1;
              return 0;
            });
          break;
        case "city":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              if (a.ClientCity.toLowerCase() < b.ClientCity.toLowerCase())
                return -1;
              if (a.ClientCity.toLowerCase() > b.ClientCity.toLowerCase())
                return 1;
              return 0;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              if (a.ClientCity.toLowerCase() < b.ClientCity.toLowerCase())
                return -1;
              if (a.ClientCity.toLowerCase() > b.ClientCity.toLowerCase())
                return 1;
              return 0;
            });
          break;
        case "region":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              if (!a.ClientState_Region) a.ClientState_Region = "";
              if (!b.ClientState_Region) b.ClientState_Region = "";

              if (
                a.ClientRegionName.toLowerCase() <
                b.ClientRegionName.toLowerCase()
              )
                return -1;
              if (
                a.ClientRegionName.toLowerCase() >
                b.ClientRegionName.toLowerCase()
              )
                return 1;
              return 0;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              if (!a.ClientState_Region) a.ClientState_Region = "";
              if (!b.ClientState_Region) b.ClientState_Region = "";

              if (
                a.ClientRegionName.toLowerCase() <
                b.ClientRegionName.toLowerCase()
              )
                return -1;
              if (
                a.ClientRegionName.toLowerCase() >
                b.ClientRegionName.toLowerCase()
              )
                return 1;
              return 0;
            });
          break;
        case "postalcode":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              return a.ClientPostalCode - b.ClientPostalCode;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              return a.ClientPostalCode - b.ClientPostalCode;
            });
          break;
        case "country":
          if (this.sortOrder == "asc")
            clientData.sort((a, b) => {
              if (a.ClientCountry.toLowerCase() < b.ClientCountry.toLowerCase())
                return -1;
              if (a.ClientCountry.toLowerCase() > b.ClientCountry.toLowerCase())
                return 1;
              return 0;
            });
          else if (this.sortOrder == "desc")
            clientData.sort((b, a) => {
              if (a.ClientCountry.toLowerCase() < b.ClientCountry.toLowerCase())
                return -1;
              if (a.ClientCountry.toLowerCase() > b.ClientCountry.toLowerCase())
                return 1;
              return 0;
            });
          break;
        default:
          console.error("Error: invalid sortField in startSorting()");
          break;
      }
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setClientTableHeight);
      this.globals.getCountryList();
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedClient: -1, // ID of the selected client, -1 if none is selected
      pageSize: 20, // Number of clients on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      searchString: "",
      sortField: "name", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if client data is requested and server did not respond yet to avoid multiple requests at the same time
      filteredClientData: [], // Stores the client data that passed the filter
      clientDataOnCurrentPage: [], // Stores the client data on the current page
      clientData: [], // Stores the whole client data from server
      timeZones: [], // List of available timezones
      regionList: [], // List of all available regions
      languageList: {},
      localesList: [],
      clientTypes: [],
      forbiddenCPs: [], // Dont Allow Properties with this name
      fpInputSince: null,
      editClientDialogData: {
        // Data for the editClient dialog
        dialogType: "", // Should be "create" or "edit"
        dialogTitle: "", // Title of the dialog
        clientData: {}, // The client data of the selected client is stored here
        currentRegionsGeneral: [], // List of regions in the selected country in the general section
        currentRegionsBilling: [], // List of regions in the selected country in the billing section
        currentTimeZonesGeneral: [],
        newCustomProperty: "", // Stores the name of a new custom property
        showAlert: false, // true --> Alert for validation errors is visible
        selectedSurvey: { SurveyId: -1 }, // Stores the selected survey on the survey page
      },
      removeCustomPropertySecurityDialogData: {
        propId: -1,
        propName: "",
      },
      showEditSurveyDialog: false,
      showDeleteSurveyModal: false,
      showImportersModal: false,
      editSurveyDialogModeAdd: true,
      invalidInputIds: [], // IDs of inputs with validation error
      lang: {
        // Contains localization strings for the selected language
        C0000: "Aktualisieren",
        C0001: "Neuer Kunde",
        C0002: "Bearbeiten",
        C0005: "Geokodierung",
        C0006: "Neuer Fragebogen",
        C0007: "Suche...",
        C0008: "Elemente pro Seite",
        C0009: "Alle",
        C0010: "Erste Seite",
        C0011: "Letzte Seite",
        C0012: "Kunden-ID",
        C0013: "Kundenname",
        C0014: "Straße",
        C0015: "Stadt",
        C0016: "Region",
        C0017: "PLZ",
        C0018: "Land",
        C0019: "ID",
        C0020: "Allgemein",
        C0021: "Kundenname",
        C0022: "Straße",
        C0023: "Adresszusatz",
        C0024: "Stadt",
        C0025: "Region",
        C0026: "Bitte auswählen...",
        C0027: "Land",
        C0028: "PLZ",
        C0029: "Kunde seit dem",
        C0030: "Zeitzone",
        C0031: "Zusätzliche Anmerkungen",
        C0032: "Kontakt",
        C0033: "Vorname",
        C0034: "Nachname",
        C0035: "Telefon",
        C0036: "Fax",
        C0037: "E-Mail",
        C0038: "Rechnungsinformationen",
        C0039: "Rechnungsempfänger",
        C0040: "Adresse",
        C0041: "Adresszusatz",
        C0042: "Stadt",
        C0043: "Region",
        C0044: "Land",
        C0045: "PLZ",
        C0046: "E-Mail",
        C0047: "Bezeichnungen",
        C0048: "Personalisierung",
        C0049: "Kundenlogo URL",
        C0050:
          "Jedes Bild-Format ist erlaubt, jedoch für beste Bildqualität, benutzen Sie PNG-Format mit transparentem Hintergrund und einer Höhe unter 100 Pixel.",
        C0051: "Begrüßungstext für Kunden",
        C0052: "Beispiel",
        C0053: "Willkommen",
        C0054: "Erlaubt Platzhalter",
        C0055: "Startseite Layout",
        C0056: "Farbkodierung",
        C0057: "MSM Navigator Standarddefinition",
        C0058: "Nachkommastellen",
        C0059: "Fragebögen",
        C0060: "ID",
        C0061: "Fragebogen",
        C0062: "Custom Properties",
        C0063: "Neue Auswertungsebene",
        C0064: "Hinzufügen",
        C0065: "Eigenschaftsbezeichnung",
        C0066: "ID",
        C0067: "Position",
        C0068:
          "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        C0069: "Abbrechen",
        C0070: "Speichern",
        C0088: "Neuer Kunde",
        C0089: "Kunden bearbeiten",
        C0090: "Diese Angabe ist erforderlich!",
        C0091: "Dies ist keine gültige Telefonnummer!",
        C0092: "Dies ist keine gültige Faxnummer!",
        C0093: "Dies ist keine gültige URL!",
        C0094: "Dies ist keine gültige E-Mail Adresse!",
        C0095: "Neuer Fragebogen",
        C0096: "Allgemein",
        C0097: "Kunde",
        C0098: "Titel",
        C0099:
          "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        C0100: "Abbrechen",
        C0101: "Speichern",
        C0102: "Fragebogen bearbeiten",
        C0103: "Sichtbarkeit",
        C0104: "Operativ",
        C0105: "Reporting",
        C0107: "Bearbeiten",
        C0108: "Fragebogen Editor",
        C0109: "Löschen",
        C0110: "Benutzerdefinierte Eigenschaft löschen",
        C0111:
          "ACHTUNG: Beim Entfernen einer Benutzerdefinierten Eigenschaft, werden auch alle zugehörigen Definitionen bei den Standorten entfernt!",
        C0112: "Soll die Benutzerdefinierte Eigenschaft",
        C0113: "wirklich gelöscht werden?",
        C0114: "Nein",
        C0115: "Ja",
        C0116: "Delete Survey",
        C0117: "Do you really want to delete the following survey?",
        C0118: "Importers",
        C0119: "Total clients count",
        C0120: "Type",
        C0121: "Status",
        C0122: "Active",
        C0123: "Inactive",
        C0124: "CX Kunde",
        C0125: "Mark as CX and create relevant custom properties",
        C0126: "Mark as CX relevant?",
        C0127: "Confirm that you want to mark this Client as CX relevant",
        C0128: "Confirm",
        C0129: "This will create additional Custom Properties",
        C0130: "Invalider Input",
        C0131: "Verbotene Eigenschaft",
        C0132: "Duplizierte Eigenschaft",
      },
    };
  },
  components: {
    SurveyManagementEditModal,
    ConfirmationDialog,
    ImporterManagement,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Buttons appearance */
.btn-top-dialog {
  height: 70px !important;
  margin: 16px 8px 16px 8px !important;
}

/* Allows popovers to expand */
.popover {
  max-width: 100%; /* Max Width of the popover (depending on the container!) */
}

/* Custom Properties textarea on edit dialog */
.textarea-custom-properties {
  display: block;
  box-sizing: padding-box;
  overflow: hidden;
}

/* Fix cursor for survey list */
#collapseSurveys tbody {
  cursor: pointer;
}

.form-check-container {
  overflow: hidden;
}

.form-check {
  float: left;
  margin-left: 2em;
}
</style>



// WEBPACK FOOTER //
// ClientManagement.vue?03747ad4